import { useCallback, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import { useResizeObserver } from "@wojtekmaj/react-hooks";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./articlepdf.scss";
import type { PDFDocumentProxy } from "pdfjs-dist";
import { IBannerResponseModel } from "../../core/models";
import ActionFooter from "../ActionFooter/ActionFooter";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const resizeObserverOptions = {};

const maxWidth = 800;

export interface IArticlePdfProps {
  content: IBannerResponseModel;
}

const ArticlePdf = ({ content }: IArticlePdfProps) => {
  const [numPages, setNumPages] = useState<number>();
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>();

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  function onDocumentLoadSuccess({
    numPages: nextNumPages,
  }: PDFDocumentProxy): void {
    setNumPages(nextNumPages);
  }

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  const pushEventForShare = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Paylaş Butonu",
          eventSegment: { baslik: content?.title, tip: "Pdf" },
          actionType: "event",
        })
      );
    }
  };

  return (
    <>
      <div className="article-pdf">
        <div className="article-pdf__container">
          <div
            className="article-pdf__container-document"
            ref={setContainerRef}
          >
            <Document
              file={content.document_url}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
            >
              {Array.from(new Array(numPages), (_el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={
                    containerWidth
                      ? Math.min(containerWidth, maxWidth)
                      : maxWidth
                  }
                />
              ))}
            </Document>
          </div>
        </div>
      </div>

      {content.page_shareurl && (
        <ActionFooter
          onHandleShare={pushEventForShare}
          content={{
            button_items: [
              {
                title: "Paylaş",
                url: content.page_shareurl,
              },
            ],
          }}
        />
      )}
    </>
  );
};

export default ArticlePdf;
